import React from "react";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import { useLayoutStyles } from "./layoutStyles";
const Layout = () => {
    const { classes } = useLayoutStyles();
    return (
        <Box data-name="Layout" className={classes.layoutRoot}>
            <Box className={classes.body}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default Layout;
